import { useApiResource } from '~/composables/api/useApiResource'

/**
 * API composable para gestionar categorías de empresas
 * Endpoint: /company-categories
 */
export const useCompanyCategoryApi = () => {
  const { loading, error, list, customEndpoint } = useApiResource('company-categories', {
    deserialize: true,
    methods: {
      list: true,
      getById: false,
      create: false,
      update: false,
      delete: false
    }
  })

  /**
   * Obtener todas las categorías sin paginación
   * Usa un tamaño de página grande para obtener todas de una vez
   */
  const getAllCategories = customEndpoint(() => ({
    url: '/company-categories',
    method: 'GET',
    params: { 'page[size]': 100 }
  }))

  return {
    loading,
    error,
    getCategories: list,
    getAllCategories
  }
}
